import { Button } from '@/components/originui/button';
import QRCode from 'react-qr-code';
import { PendingTransaction } from '@/types/api/bankid/v2/transaction';
import { useCancelTransaction } from '../api/cancel-transaction';
import { Spinner } from '@/shared/components/spinner';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';

type TransactionPendingProps = {
  transaction: PendingTransaction;
  reset: () => void;
  showQR: boolean;
};

export function TransactionPending({ transaction, showQR, reset }: TransactionPendingProps) {
  const mutation = useCancelTransaction({ mutationConfig: { onMutate: reset } });

  return (
    <>
      <h3 className="text-xl leading-relaxed font-semibold mt-6">Inväntar BankID...</h3>

      {showQR ? (
        <>
          <p className="text-base leading-7 text-gray-700 dark:text-gray-300">Öppna BankID-appen och skanna QR-koden</p>
          <QRCode value={transaction.qrCode} size={164} />
        </>
      ) : (
        <Spinner />
      )}

      <LoadingButton
        isLoading={mutation.isPending}
        onClick={() => mutation.mutate({ transactionId: transaction.id })}
        variant="outline"
      >
        Avbryt
      </LoadingButton>
    </>
  );
}
